<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-card title="Create New API Key">
          <b-card-body>
            <b-form @submit.prevent="createApiKeyHandler">
              <b-form-group label="Description" label-for="description">
                <b-form-input
                  id="description"
                  v-model="description"
                  placeholder="Enter API key description"
                  required
                ></b-form-input>
              </b-form-group>
              <b-button type="submit" variant="primary">
                Create API Key
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { addApiKey } from '@/services/ApiKeyService';
import { BButton, BCard, BCardBody, BCol, BForm, BFormGroup, BFormInput, BRow } from 'bootstrap-vue';

export default {
  name: "AddApiKey",
  components: {
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BRow
  },
  data() {
    return {
      description: ''
    };
  },
  methods: {
    async createApiKeyHandler() {
      if (!this.description) return;
      try {
        await addApiKey(this.description);
        this.$bvToast.toast('API key created successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
        this.$router.push('/apikeys');
      } catch (error) {
        this.$bvToast.toast('Error creating API key: ' + (error.response?.data?.message || error.message), {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
};
</script>
